export const roleOptions = [
  { label: "User", value: "user" },
  { label: "Report Manager", value: "uploader" },
  { label: "Admin", value: "admin" },
  { label: "Warehouse Receiver", value: "warehouse_receiver" },
  { label: "Extension Worker", value: "extension_worker" },
  { label: "Copy Writer", value: "copy_writer" },
  { label: "Copy Writer Manager", value: "copy_writer_manager" },
  { label: "Enforcer", value: "enforcer" },
  { label: "Warehouse Lead", value: "warehouse_lead" },
  { label: "Transparency", value: "transparency" },
];

export const roleOptionsArrayOnString = roleOptions.map((role) => role.value);

export const getRoleLabel = (roleValue?: string): string => {
  if (!roleValue) return "";
  const role = roleOptions.find(
    (r) => r.value.toLowerCase() === roleValue.toLowerCase(),
  );
  return role?.label || roleValue;
};
